import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

export const RecurringDetailModel = t
  .model('Recurring', {
    id: t.optional(t.string, ''),
    enrollment_id: t.optional(t.string, ''),
    reference_number: t.optional(t.string, ''),
    biller_alias_name: t.optional(t.string, ''),
    merchant_id: t.optional(t.string, ''),
    merchant_name: t.optional(t.string, ''),
    wallet_id: t.optional(t.string, ''),
    full_name: t.optional(t.string, ''),
    mobile_no: t.optional(t.string, ''),
    amount: t.optional(t.number, 0),
    currency_code: t.optional(t.string, ''),
    sof: t.optional(t.string, ''),
    frequency: t.optional(t.string, ''),
    payment_at: t.optional(t.number, 0),
    status: t.optional(t.string, ''),
    reason: t.maybeNull(t.string),
    remind_me_at: t.optional(t.number, 0),
    recurring_type: t.optional(t.string, ''),
    pending_at: t.optional(t.string, ''),
    approved_at: t.optional(t.string, ''),
    rejected_at: t.optional(t.string, ''),
    rejected_by: t.optional(t.string, ''),
    description: t.optional(t.string, ''),
    created_at: t.optional(t.string, ''),
    created_by: t.optional(t.string, ''),
    updated_at: t.optional(t.string, ''),
    updated_by: t.optional(t.string, ''),
    remind_me_flag: t.optional(t.boolean, false),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default RecurringDetailModel;
